export default {
  name: 'patient-list-select',
  data () {
    return {
    }
  },
  props: {
    patients: Array,
    sortBy: Function,
    getArrow: Function,
    searchList: Function
  },
  computed: {
    orderedPatients () {
      return this.patients
    }
  },
  methods: {
    /** 全選択チェックボックス */
    selectAllCheckbox: function  () {
      var checked = document.querySelector("input.patient-checkbox-all").checked
      Array.prototype.map.apply(document.querySelectorAll('input.patient-checkbox'), [function (e) {
        e.checked = checked
      }])
      var data = {
        type:        'facility',
        sel_flag:    checked ? 1 : 0,
        facility_id: this.$router.currentRoute.params['facilityId'],
        user_id:     this.$store.getters.userId
      }
      this.updateSelFlag(data)
    },
    /** 選択チェックボックス */
    onChangeCheckbox: function (elm) {
      var data = {
        type:        'patient',
        sel_flag:    elm.checked ? 1 : 0,
        patient_id:  elm.value,
        facility_id: this.$router.currentRoute.params['facilityId'],
        user_id:     this.$store.getters.userId
      }
      this.updateSelFlag(data)
    },
    /** 選択状態更新 */
    updateSelFlag: function (selFlagArr) {
      var self = this
      var callback = function () {
        self.searchList('sort')
      }
      this.$store.dispatch('PATIENT_SET_SEL_FLAG', {data: selFlagArr, callback: callback})
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/patient-list-select.js